"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.number.constructor");require("core-js/modules/es6.regexp.replace");require("core-js/modules/es6.function.name");







































































var _user = require("@/utils/user"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { name: 'MapCenter', data: function data() {return { mapSrc: '', mapPosData: [], // 列表数据
      starLeft: 243, actualX: 0, typeList: [{ 'key': '0', 'value': '普通地点' }, { 'key': '1', 'value': '会客厅地点' }], addPos: false, title: '', mapId: '', delIndex: '', searchData: { page: 1, // 页码条数
        rows: 10 }, addData: { id: '', mapId: '', name: '', type: '' }, rules: { name: [{ required: true, message: '请输入巡点', trigger: 'blur' }], type: [{ required: true, message: '请选择地点类型', trigger: 'blur' }] } };}, mounted: function mounted() {var self = this;self.addData.mapId = self.$route.params.parentId;self.handleGetMapInfo();self.getMapPosList(self.addData.mapId);}, methods: { getMapPosList: function getMapPosList(mapId) {var self = this;self.mapPosData = [];self.addData.mapId = mapId;var path = '/api/temi/robot/map/' + mapId + '/pos';self.getData(path, {}, function (res) {// 偏移减少了
        /* if (self.delIndex !== '') {
          for (var i in res) {
            if (i >= self.delIndex) {
              res[i].x = res[i].x + 150
              self.modMapPos(res[i])
            }
          }
          self.delIndex = ''
        } */self.mapPosData = res;});}, handleGetMapInfo: function handleGetMapInfo() {var self = this;self.getData('/api/temi/robot/map?id=' + self.addData.mapId, {}, function (res) {if (res) {self.mapSrc = res[0].image;}});}, returnFun: function returnFun() {// 返回上一级
      // this.$router.push('/robot/map')
      this.$router.go(-1);}, checkPermission: _user.checkPermission, addFun: function addFun() {// 新增
      this.title = '新增';this.addPos = true;}, closeDiglog: function closeDiglog() {// 关闭弹出层
      this.$refs['addPos'].resetFields();this.cleanData();this.addPos = false;
    },
    updateMenu: function updateMenu(pos) {// 修改操作
      console.log(pos);
      this.title = '修改';
      var self = this;
      self.addPos = true;
      self.addData = {
        id: pos.id,
        name: pos.name,
        mapId: pos.mapId,
        type: pos.type + '' };

      console.log(self.addData);
    },
    onSubmit: function onSubmit() {// 新增提交操作
      var self = this;
      self.$refs.addPos.validate(function (valid) {
        if (valid) {
          var mapId = self.addData.mapId;
          var path = '/api/temi/robot/map/' + mapId + '/pos';
          self.postData(path, self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.getMapPosList(mapId);
          });
        } else {
          return false;
        }
      });
    },
    delMenu: function delMenu(pos, index) {// 删除操作
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        var path = '/api/temi/robot/map/' + pos.mapId + '/pos?id=' + pos.id;
        self.delData(path, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.onCencal();
          self.delIndex = index;
          self.getMapPosList(pos.mapId);
        });
      }).catch(function () {});
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.cleanData();
      this.addPos = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData.name = '';
      this.addData.type = '';
      this.addData.id = '';
    },
    move: function move(e, pos, index) {var _this = this;
      var self = this;
      var odiv = e.target.parentNode; // 获取目标元素
      // 阻止默认事件的方法,如果不阻止默认事件onmouseup会无法触发
      e.preventDefault();
      // 算出鼠标相对元素的位置
      var starX = odiv.style.left.replace('px', '');
      var starY = odiv.style.top.replace('px', '');
      var disX = e.clientX;
      var disY = e.clientY;
      console.log('starX->', starX);
      console.log('disX->', disX);
      document.onmousemove = function (e) {
        // 鼠标按下并移动的事件
        // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        // 因为img居中对齐，所以还要减去目标元素距离body的偏移量
        var left = e.clientX - disX + Number(starX);
        var top = e.clientY - disY + Number(starY);
        self.actualX = e.clientX - self.starLeft;
        console.log('x->', left);
        console.log('y->', top);
        console.log('x实际移动：', self.actualX);
        // 移动当前元素
        var yIndex = parseInt(index % 4);
        var xOrigin = 0 - yIndex * 150;
        xOrigin = xOrigin + self.actualX;

        odiv.style.left = xOrigin + 'px';
        odiv.style.top = top + 'px';
      };
      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
        var starY = odiv.style.top.replace('px', '');
        var yIndex = parseInt(index / 4);
        var yOrigin = yIndex * 30;
        starY = parseInt(starY) + yOrigin;

        console.log(self.actualX);
        var posData = {
          id: pos.id,
          mapId: pos.mapId,
          x: self.actualX,
          y: starY };

        _this.modMapPos(posData);
      };
    },
    modMapPos: function modMapPos(posData) {
      var path = '/api/temi/robot/map/' + posData.mapId + '/pos';
      this.postData(path, posData, function (res) {});
    },
    imageLoad: function imageLoad(e, pos, index) {
      var odiv = e.target.parentNode; // 获取目标元素
      var x = pos.x ? pos.x : 0;
      var y = pos.y === null ? 0 : pos.y;
      // 偏移
      var xIndex = parseInt(index % 4);
      console.log('lmode:', xIndex);
      console.log(pos.name, index);
      var xOrigin = 0 - xIndex * 150;
      xOrigin = xOrigin + x;
      var yIndex = parseInt(index / 4);
      var yOrigin = yIndex * 30;
      console.log('原来Y->', y);
      y = y - yOrigin;
      console.log('偏移Y->', yIndex);
      console.log('偏移之后Y->', y);
      odiv.style.left = xOrigin + 'px';
      odiv.style.top = y + 'px';
    } } };exports.default = _default;